/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilestoreAttachmentRequest
 */
export interface FilestoreAttachmentRequest {
    /**
     * 
     * @type {number}
     * @memberof FilestoreAttachmentRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FilestoreAttachmentRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreAttachmentRequest
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachmentRequest
     */
    input?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachmentRequest
     */
    output?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachmentRequest
     */
    primary?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachmentRequest
     */
    scheduler?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachmentRequest
     */
    worker?: boolean;
}

/**
 * Check if a given object implements the FilestoreAttachmentRequest interface.
 */
export function instanceOfFilestoreAttachmentRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FilestoreAttachmentRequestFromJSON(json: any): FilestoreAttachmentRequest {
    return FilestoreAttachmentRequestFromJSONTyped(json, false);
}

export function FilestoreAttachmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilestoreAttachmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'input': !exists(json, 'input') ? undefined : json['input'],
        'output': !exists(json, 'output') ? undefined : json['output'],
        'primary': !exists(json, 'primary') ? undefined : json['primary'],
        'scheduler': !exists(json, 'scheduler') ? undefined : json['scheduler'],
        'worker': !exists(json, 'worker') ? undefined : json['worker'],
    };
}

export function FilestoreAttachmentRequestToJSON(value?: FilestoreAttachmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'path': value.path,
        'input': value.input,
        'output': value.output,
        'primary': value.primary,
        'scheduler': value.scheduler,
        'worker': value.worker,
    };
}

